import { Routes } from "@angular/router";

import { AdminPageComponent } from '../admin/components/admin-page/admin-page.component';
import { DashboardPageComponent } from '../admin/components/dashboard-page/dashboard-page.component';
import { ReviewPageComponent } from '../admin/components/review-page/review-page.component';
import { UnauthorizedPageComponent } from '../admin/components/unauthorized-page/unauthorized-page.component';
import { DocumentsPageComponent } from '../admin/components/documents-page/documents-page.component';

import { IsLoggedIn } from '../shared/guards/is-logged-in';

export const routes: Routes = [
  {
    path: 'admin',
    component: AdminPageComponent,
    canActivate: [IsLoggedIn],
    children: [
      { path: "review", component: ReviewPageComponent },
      { path: "dashboard/:orgId", component: DashboardPageComponent },
      { path: "unauthorized", component: UnauthorizedPageComponent },
      { path: "documents/:orgId", component: DocumentsPageComponent },
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/routes/admin.route.ts